export default serviceClient => {
  return {
    async rowExists({rootState, commit}, {row}) {
      if (!row.metadata?.id) {
        return false;
      }
      try {
        await serviceClient.getRow(
          rootState.accessToken,
          rootState.customer,
          row.metadata.id
        );
        return true;
      } catch (error) {
        if (error.status === 404) {
          return false;
        }
        commit('setError', error, {root: true});
      }
    },
    async saveRow({rootState, commit}, {row, saveAsNew = true}) {
      try {
        if (saveAsNew) {
          return await serviceClient.saveRow(
            rootState.accessToken,
            rootState.customer,
            row
          );
        } else {
          return await serviceClient.updateRow(
            rootState.accessToken,
            rootState.customer,
            row
          );
        }
      } catch (error) {
        commit('setError', error, {root: true});
      }
    }
  };
};
